export enum IdPParamKeys {
  UserSub = '{{userSub}}',
  Account = '{{account}}',
  ManagementGroupId = '{{managementGroupId}}',
}
